<!-- Ohne Konfiguration gibt die Komponente nichts aus, genau wie <his-file-upload />: -->
<!-- Ist das Uploadfeld versteckt oder gar nicht konfiguriert, antwortet der Server mit -->
<!-- einem leeren Body, den der HisFileUploadService verschluckt - configuration() bleibt -->
<!-- dann null, ebenso solange die Anfrage noch laeuft oder fehlgeschlagen ist. -->
@if (configuration()) {

<!-- Die Auswahl wird wie in der JSF-Komponente als Definitionsliste ausgegeben: eine <dl
     class="currentValue"> ueber die gesamte Auswahl, darin pro Datei ein <dt> mit dem Namen und
     ein <dd> mit den Aktionen. Weil ein <dl> zwischen sich und seinen <dt>/<dd> kein weiteres
     Element zulaesst, ist <his-select-file-item /> ein Attribut des <dd>. -->
@if (value()?.length) {
<dl class="currentValue">
    @for (file of value(); track fileKey(file)) {
    <dt><span>{{ filenameOf(file) }}</span></dt>
    <dd
        his-select-file-item
        [file]="file"
        [configKey]="configKey()"
        [localMedia]="localMediaOf(file)"
        [disabled]="isDisabled()"
        [readonly]="isReadonly()"
        [processProperties]="processProperties()"
        [allowComment]="allowComment()"
        [disableDownload]="disableDownloadOf(file)"
        [propertyCustomDisplayCategories]="propertyCustomDisplayCategories()"
        [propertyCustomDisplayIcon]="propertyCustomDisplayIcon()"
        [propertyCustomDisplay]="propertyCustomDisplay()"
        (commentChange)="updateComment(file, $event)"
        (remove)="removeFile(file)"></dd>
    }
</dl>
}
@if (canEditSelection()) {
<button type="button" (click)="editSelection()" hisImage="pencil" class="transparent" [disabled]="isDisabled()">
    {{ editSelectionLabelKey() | hisUi: translatedLabel() }}
</button>
}
@if (categories.visible()) {
<div class="his-select-file__category">
    <h3>{{ 'common.components.selectFile.category.heading' | hisUi }}</h3>
    <his-plam [label]="'common.components.selectFile.category' | hisUi" [required]="true" showLabelTop>
        @if (categories.unchangeable()) {
        <span #content class="plamContentText">{{ categories.selected()?.defaulttext }}</span>
        } @else {
        <p-autoComplete
                        #content
                        [dropdown]="true"
                        [forceSelection]="true"
                        [required]="true"
                        optionLabel="defaulttext"
                        [suggestions]="categories.suggestions()"
                        (completeMethod)="categories.filterSuggestions($event)"
                        [ngModel]="categories.selected()"
                        (ngModelChange)="onCategoryChange($event)"
                        [ngModelOptions]="{ standalone: true }" />
        }
    </his-plam>
</div>
}
@if (showConfigurationLink) {
<div class="his-select-file__config-link">
    <!-- TODO: Der Text ist hart kodiert, weil es serverseitig noch keinen
             Übersetzungsschlüssel dafür gibt. Sobald einer angelegt ist, hier
             auf hisUiService.translate(...) umstellen. -->
    <a
       [href]="configurationUrl()"
       target="_blank"
       rel="noopener"
       hisImage="COG"
       title="Konfiguration anzeigen">Konfiguration anzeigen</a>
</div>
}

<!-- Schliessen-Icon, [ESC] und Klick auf den Backdrop verhalten sich wie der Abbrechen-Button --
     und sind deshalb auch waehrend eines laufenden Uploads gesperrt, genau wie dieser. -->
<p-dialog
          [(visible)]="showChangeDialog"
          [closable]="!isUploadActive()"
          [closeAriaLabel]="'common.close' | hisUi"
          [closeOnEscape]="!isUploadActive()"
          [dismissableMask]="!isUploadActive()"
          [modal]="true"
          [blockScroll]="true"
          header="{{ editSelectionTitleKey() | hisUi }}"
          (onHide)="onSelectionClosed()">
    <!-- Als pTemplate="content" statt als projizierter Inhalt: so entstehen die Panels bei jedem -->
    <!-- Oeffnen neu. Projiziert wuerden sie beim Schliessen nur aus dem DOM geloest, wobei die -->
    <!-- Angular-Animation ihre Inline-Styles verwirft - ein zugeklapptes Panel waere beim naechsten -->
    <!-- Oeffnen in voller Hoehe zu sehen, weil sein Animationszustand sich nicht geaendert hat. -->
    <ng-template pTemplate="content">
        @if (showEditSelectionHelptext() && editSelectionHelptext) {
        <p class="helptext" [innerHTML]="editSelectionHelptext"></p>
        }
        <p-accordion [(value)]="activeSelectionPanel">
            @if (localMediaAvailable()) {
            <p-accordion-panel value="0">
                <p-accordion-header>
                    <div>{{ 'common.components.selectFile.localMedia.heading' | hisUi }}</div>
                </p-accordion-header>
                <p-accordion-content (keydown)="keepCaretKeysInPanel($event)">
                    <his-select-file-local-media
                                                 [media]="filteredLocalMedia()"
                                                 [mediaLoaded]="localMediaLoaded()"
                                                 [categories]="categories.all()"
                                                 [optionalLocalMediaResourceInfo]="optionalLocalMediaResourceInfo()"
                                                 [selectedMediaReferences]="selectedLocalMediaReferences()"
                                                 [disabled]="isDisabled() || isUploadActive()"
                                                 (selectionChange)="applyLocalMedia($event)"
                                                 (cancelSelection)="cancelSelection()" />
                </p-accordion-content>
            </p-accordion-panel>
            }
            @if (eudiwAvailable()) {
            <p-accordion-panel value="2">
                <p-accordion-header>
                    <div>{{ 'common.components.selectFile.eudiw.heading' | hisUi }}</div>
                </p-accordion-header>
                <p-accordion-content (keydown)="keepCaretKeysInPanel($event)">
                    <div class="his-select-file__eudiw">
                        @if (eudiwQueryState().status !== 'error') {
                        <his-info-panel i18nKey="common.components.selectFile.eudiw.helptext" />
                        }

                        @if (eudiwQuery(); as query) {
                        <div
                             class="his-select-file__eudiw-query"
                             [attr.aria-busy]="eudiwQueryState().status === 'loading'">
                            <img
                                 [src]="'data:image/png;base64,' + query.qrCodeImageData"
                                 [alt]="'common.components.selectFile.eudiw.qrCodeAlttext' | hisUi" />
                            <dl>
                                <dt>{{ 'common.components.selectFile.eudiw.redirectUrl' | hisUi }}</dt>
                                <dd>
                                    <a
                                       [href]="query.redirectUrl"
                                       target="_blank"
                                       rel="noopener">{{ 'common.components.selectFile.eudiw.redirectUrlLink' | hisUi:
                                        query.redirectUrl
                                        }}</a>
                                </dd>
                            </dl>
                        </div>
                        }

                        @if (eudiwQueryState().status === 'error') {
                        <div class="plamWarningtext" role="alert">
                            @if (eudiwApplyErrorReason() === 'queryNotFound') {
                            {{ 'common.components.selectFile.eudiw.queryNotFound' | hisUi }}
                            } @else {
                            {{ 'common.components.selectFile.eudiw.queryCreationError' | hisUi }}
                            }
                        </div>
                        } @else if (eudiwApplyErrorReason(); as errorReason) {
                        <div class="plamWarningtext" role="alert">
                            @switch (errorReason) {
                            @case ('unavailable') {
                            {{ 'common.components.selectFile.eudiw.resourceUnavailable' | hisUi }}
                            }
                            @default {
                            {{ 'common.components.selectFile.eudiw.resourceRetrievalError' | hisUi }}
                            }
                            }
                        </div>
                        }

                        <div class="his-select-file__eudiw-actions">
                            @if (eudiwQueryState().status === 'ready') {
                            <button
                                    type="button"
                                    hisImage="TICK"
                                    class="button_highlighted"
                                    (click)="applyEudiw()"
                                    [disabled]="eudiwApplyState().status === 'loading'">{{ 'common.apply' | hisUi
                                }}</button>
                            }
                            <button
                                    type="button"
                                    hisImage="ARROW_REFRESH"
                                    class="button_highlighted orange"
                                    (click)="createEudiwQuery()"
                                    [disabled]="eudiwQueryState().status === 'loading' || eudiwApplyState().status === 'loading'">{{
                                'common.components.selectFile.eudiw.refreshResourceQuery' | hisUi }}</button>
                            <button
                                    type="button"
                                    hisImage="PANEL_CLOSE"
                                    class="button_highlighted blue"
                                    (click)="cancelSelection()">
                                {{ 'common.cancel' | hisUi }}
                            </button>
                        </div>
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
            }
            @if (uploadAvailable()) {
            <p-accordion-panel value="1">
                <p-accordion-header>
                    <div>{{ 'common.components.selectFile.uploadedResource.heading' | hisUi }}</div>
                </p-accordion-header>
                <p-accordion-content (keydown)="keepCaretKeysInPanel($event)">
                    <his-plam [label]="'common.inputFile' | hisUi" renderLabelAsDiv>
                        <his-file-upload
                                         #content
                                         #uploadModel="ngModel"
                                         [configKey]="configKey()"
                                         [(ngModel)]="uploadDraft"
                                         [categoryIds]="categories.uploadIds()"
                                         required
                                         disableComment
                                         disableHelptext
                                         disableHelptextAbove
                                         disableHelptextBelow
                                         disableFeedback
                                         showCategoryIfUnique="false"
                                         multiple="false" />
                    </his-plam>
                    <button type="button" hisImage="TICK" class="button_highlighted" (click)="applyUpload()"
                            [disabled]="isUploadActive()">
                        {{ 'common.apply' | hisUi }}
                    </button>
                    <button type="button" hisImage="PANEL_CLOSE" class="button_highlighted blue"
                            (click)="cancelSelection()" [disabled]="isUploadActive()">
                        {{ 'common.cancel' | hisUi }}
                    </button>
                </p-accordion-content>
            </p-accordion-panel>
            }
        </p-accordion>
    </ng-template>
</p-dialog>

}